// Datenbasis aller Pflichtfortbildungen für Pflegeeinrichtungen.
// 45 Min Unterricht = 1 FP. 1 UE = 1 FP (nach gängigem System für Fortbildungsanbieter).

export const PFLICHT_THEMEN = [
  {
    slug: "hygiene",
    title: "Hygiene & Infektionsprävention",
    ue: 8,
    audience: "Alle Mitarbeitenden",
    short: "RKI-konforme Standards, Händedesinfektion, multiresistente Erreger, Ausbruchsmanagement.",
  },
  {
    slug: "expertenstandards",
    title: "Expertenstandards (DNQP)",
    ue: 8,
    audience: "Pflegefachkräfte",
    short: "Aktuelle DNQP-Standards praxisnah übersetzt – von Dekubitus bis Sturz, von Schmerz bis Kontinenz.",
  },
  {
    slug: "notfall-erste-hilfe",
    title: "Notfallmanagement & Erste Hilfe Update",
    ue: 9,
    audience: "Alle Mitarbeitenden",
    short: "Reanimation, Defi, Erstickung, Bewusstlosigkeit. Jährliche Auffrischung nach DGUV.",
  },
  {
    slug: "arzneimittelsicherheit",
    title: "Arzneimittelsicherheit",
    ue: 8,
    audience: "Pflegefachkräfte",
    short: "Stellen, Richten, Verabreichen – sicher, dokumentiert und MD-prüfungsfest.",
  },
  {
    slug: "datenschutz-dsgvo",
    title: "Datenschutz nach DSGVO",
    ue: 4,
    audience: "Alle Mitarbeitenden",
    short: "Schweigepflicht, Auskunftsrecht, Dokumentationspflicht – verständlich und alltagstauglich.",
  },
  {
    slug: "arbeitsschutz",
    title: "Arbeitsschutz & Unfallverhütung",
    ue: 4,
    audience: "Alle Mitarbeitenden",
    short: "DGUV V1 Unterweisung, ergonomisches Arbeiten, Gefährdungsbeurteilung im Pflegealltag.",
  },
  {
    slug: "brandschutz",
    title: "Brandschutz",
    ue: 2,
    audience: "Alle Mitarbeitenden",
    short: "Verhalten im Brandfall, Flucht- und Rettungswege, Löschmittel – jährliche Unterweisung.",
  },
  {
    slug: "dekubitusprophylaxe",
    title: "Dekubitusprophylaxe",
    ue: 8,
    audience: "Pflegefachkräfte",
    short: "Risikoeinschätzung, Lagerungstechniken, Hilfsmittel – nach aktuellem Expertenstandard.",
  },
  {
    slug: "sturzprophylaxe",
    title: "Sturzprophylaxe",
    ue: 8,
    audience: "Pflegefachkräfte",
    short: "Assessments, Sturzhergangsanalyse, Maßnahmenplanung. MD-relevant und dokumentationspflichtig.",
  },
  {
    slug: "schmerzmanagement",
    title: "Schmerzmanagement",
    ue: 16,
    audience: "Pflegefachkräfte",
    short: "Akut- und chronischer Schmerz, Assessments, medikamentöse & nicht-medikamentöse Strategien.",
  },
  {
    slug: "demenz-kommunikation",
    title: "Demenz & Kommunikation",
    ue: 16,
    audience: "Alle in der Pflege & Betreuung",
    short: "Validation, herausforderndes Verhalten, biografische Arbeit – Sicherheit im Umgang.",
  },
];

export const PFLICHT_REZERT = [
  {
    slug: "rezert-betreuungskraft",
    title: "Rezertifizierung Betreuungskraft",
    legal: "§ 43b SGB XI",
    ue: 16,
    interval: "jährlich",
    short: "16 UE Pflichtfortbildung pro Kalenderjahr – Voraussetzung für die weitere Tätigkeit als Betreuungskraft.",
  },
  {
    slug: "rezert-praxisanleitung",
    title: "Rezertifizierung Praxisanleitung",
    legal: "§ 4 PflAPrV",
    ue: 24,
    interval: "jährlich",
    short: "24 UE berufspädagogische Fortbildung pro Jahr – verpflichtend für alle Praxisanleiter:innen seit 2020.",
  },
];

// Empfehlung des Gesetzgebers / der Pflegekassen: 8–16 Std. pro Mitarbeitenden / Jahr.
export const PFLICHT_RAHMEN = {
  basisStunden: "8–16",
  praxisanleiterStunden: 24,
  fpRegel: "45 Min Unterricht = 1 Fortbildungspunkt (FP)",
};
